/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnfollowZoneMutationVariables = Types.Exact<{
  label_id: Types.Scalars['String'];
}>;


export type UnfollowZoneMutation = { __typename: 'Mutation', unfollowLabel: { __typename: 'LabelFollow', id: string | null, user_id: string | null, label_id: string | null } | null };


export const UnfollowZoneDocument = gql`
    mutation unfollowZone($label_id: String!) {
  unfollowLabel(label_id: $label_id) {
    id
    user_id
    label_id
  }
}
    `;
export type UnfollowZoneMutationFn = Apollo.MutationFunction<UnfollowZoneMutation, UnfollowZoneMutationVariables>;

/**
 * __useUnfollowZoneMutation__
 *
 * To run a mutation, you first call `useUnfollowZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowZoneMutation, { data, loading, error }] = useUnfollowZoneMutation({
 *   variables: {
 *      label_id: // value for 'label_id'
 *   },
 * });
 */
export function useUnfollowZoneMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowZoneMutation, UnfollowZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowZoneMutation, UnfollowZoneMutationVariables>(UnfollowZoneDocument, options);
      }
export type UnfollowZoneMutationHookResult = ReturnType<typeof useUnfollowZoneMutation>;
export type UnfollowZoneMutationOptions = Apollo.BaseMutationOptions<UnfollowZoneMutation, UnfollowZoneMutationVariables>;